<template>
    <div class="product-training">
        <div class="expert-div-lead" style="text-align:center;">
            <div class="expert-responsive-lead">
                <h3><span>EXPERT IN</span><strong>HEARING Protection</strong></h3>
                <img src="/images/st-learning/ear-protection/exp-main-hearing.png" alt="hearing protection">
            </div>
            <div class="expert-div-info" style="text-align:center;" ref="mobileView" id="mobile-hearing">
                <h2>Superior & Affordable <br>Hearing Protection</h2>
                <p>
                    Noise-induced hearing loss is a common workplace injury that is 100% preventable. Protective Industrial Products is proud to offer a complete line of hearing protection options to keep workers protected from loud working environments, while achieving all-day comfort and optimal sound attenuation.
                </p>
                <img src="/images/st-learning/ear-protection/ear-muff-hear-image.jpg" width="1000" height="auto"
                    alt="Electronic Ear Muff" style="margin:10px 0 0 -50px;border-bottom:1px solid #666;" />
            </div>
            <a href="javascript:void(0);" class="expert-read-info">
                <span @mousedown="showMobile" ref="readMore"><small>READ MORE</small><font-awesome-icon :icon="['fas', 'chevron-down']" /></span>
                <span @mousedown="hideMobile" ref="readLess"><small>CLOSE</small><font-awesome-icon :icon="['fas', 'chevron-up']" /></span>
            </a>
        </div>

        <div class="expert-div" style="padding-top:50px;">

            <h2 class="none" id="expert-h2-heading">Ear Muffs</h2>

            <p class="main">
                Ear Muffs provide a more secure form of hearing protection, especially because they are easier to use and allow the user to gain maximum protection from the product.
            </p>

            <br />

            <h2 class="space">Technology</h2>

            <p class="main">
                All hearing protection methods have capability to reduce noise. Devices with only this function are called passive hearing protectors. Electronic styles integrate advanced electronics with the ear muffs to suit multiple work environments.               
            </p>

            <div class="expert-sub-menu">
                <span class="icon icon-hamburger" id="borger-1" @mousedown="burgerClicked('borger-1')"><font-awesome-icon :icon="['fas', 'bars']" /></span>
            </div>

            <div id="tech-th" class="expert-sub-menu-dropdown" ref="top-dropdown">
                <div id="tech-th-passive" style="border-bottom:solid 3px #cd1b00;" ref="tech-th-passive" @mouseover="techHover">
                    <img id="tech-th-passive-img" src="/images/st-learning/ear-protection/PASSIVE--THUMBNAIL--150x69.jpg" width="150" height="69" alt="passive ear muff icon" @mouseover="techHover"/> <br>PASSIVE
                </div>
                <div id="tech-th-electronic" ref="tech-th-electronic" @mouseover="techHover">
                    <img id="tech-th-electronic-img" src="/images/st-learning/ear-protection/ELECTRONIC--THUMBNAIL--150x90.jpg" width="150" height="69" alt="electronic ear muff icon" @mouseover="techHover" /> <br> ELECTRONIC
                </div>
            </div>

            <div id="tech-img">
                <img src="/images/st-learning/ear-protection/img-exp-passive---en.jpg" alt="passive ear muff" id="tech-img-passive" ref="tech-img-passive" />
                <img src="/images/st-learning/ear-protection/img-exp-electronic---en.jpg" alt="electronic ear muff" id="tech-img-electronic" style="display:none;" ref="tech-img-electronic"/>
            </div>

            <div id="tech-txt">

                <div id="tech-txt-passive" ref="tech-txt-passive">
                    <p>
                        <strong>PASSIVE EAR MUFFS</strong> - Noise blocking muffs attenuate noise using the highest quality insulating and dampening materials and are offered in multiple levels of protection to fit your working environment. Slim profile increases stability and reduces the risk of snagging in confined areas &bull; Available in Headband, Cap Mounted and Neckband Styles.
                    </p>
                </div>

                <div id="tech-txt-electronic" style="display:none;" ref="tech-txt-electronic">
                    <p>
                        <strong>ELECTRONIC EAR MUFFS</strong> - Available Level Dependent System uses microphones mounted on each ear cup that limits all sounds through the speakers to a safe level, allowing for communication while remaining protected against hazardous noise &bull; Available AM/FM Radio for monotonous and stationary tasks in noisy areas, to increase motivation and efficiency.
                    </p>
                </div>
            </div>

        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider" />

        <div class="expert-div">
            <h2 class="none">Styles</h2>
            <p class="main">
                When combining hearing protection with other protective equipment it is important that the hearing protection attenuation is not impaired due to the combination. For example the temples of safety eyewear should be of a low profile type to minimize the reduction of performance. If you are uncertain if your other equipment will affect the attenuation it may be wise to choose an ear muff with a slightly higher protection level than what the analyze method is stating.
            </p>

            <div id="styles-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/ear-protection/263-NP111---FR.jpg" width="236" height="236" alt="headband style ear muff" style="margin:0px 10px;" />
                        <p><strong>HEADBAND</strong><br /><em>Electronic & Passive</em><br />
                            Light, durable construction with easy size adjustment provides the perfect fit for all head sizes. Unlike other ear muffs on the market, our line is made with a high performance, thermoplastic material that allows the headband to be stretched without warping or distorting.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/263-NP119---FR.jpg" width="236" height="236" alt="hard hat mounted ear muff" style="margin:0px 20px;" />
                        <p>
                            <strong>CAP MOUNTED</strong><br />
                            <em>Electronic & Passive</em><br />Fits most cap-style hard hats with universal slots. They can be worn snapped into place on the ear, slightly off the ear to allow hearing, or pivoted up and away when not needed.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/263-NP120---FR.jpg" width="236" height="236" alt="neckband ear muff" style="margin:0px 20px;" /> <p>
                            <strong>NECKBAND</strong><br />
                            <em>Passive Only</em><br />For use in conjunction with bump caps, hard hats without universal slots or head-mounted face protection. Adjustable head support strap ensures that muffs stay in position at all times.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider" />

        <div class="expert-div">
            <h2 class="none">NRR Rating</h2>
            <p class="main">
                When selecting hearing protection you need information on the character of the noise; sound pressure level (dB), duration and frequency content (Hz). The level of the disturbing noise and its frequency distribution is of great importance. High levels of low frequency noise have the inconvenience of making it difficult to understand speech (below 500Hz).
            </p>

            <p class="main">
                A product's Noise Reduction Rating, or NRR, measures the effectiveness of a hearing protector to decrease exposure to sounds. The higher the rating, the stronger the protection. While it is important to offer workers enough protection, it is actually dangerous to over protect them as well. If the NRR rating is too high for the environment (specifically, levels below 70dB), difficulties with communication and hearing warning signals. It will cause the user to feel isolated and to remove the hearing protector.
            </p>
            <img src="/images/st-learning/ear-protection/img-exp-hearing-dbchart.jpg" alt="noise reduction rating chart" id="nrr-rating" />
        </div>


        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider" />

        <div class="expert-div">
            <h2 class="none" style="font-family:'nimbus-sans-extended'; text-transform:uppercase; font-weight:400; font-size:48px; line-height:50px;">Ear Plugs</h2>
            <p class="main">
                Ear plugs are a popular choice because they are seen as the most economical solution, and they can easily be worn with other PPE.
                </p>
            <div class="expert-sub-menu">
                <span class="icon icon-hamburger" id="borger-2" @mousedown="burgerClicked('borger-2')"><font-awesome-icon :icon="['fas', 'bars']" /></span>
            </div>
            <div id="tech-th" class="expert-sub-menu-dropdown" ref="bottom-dropdown">
                <div id="tech-th-single" style="border-bottom:solid 3px #cd1b00;" ref="tech-th-single" @mouseover="techHover">
                    <img id="tech-th-single-img" src="/images/st-learning/ear-protection/SINGLE-USE THUMBNAIL--150X69.jpg" width="150" height="69" alt="passive ear muff icon"  @mouseover="techHover" /> <br>SINGLE USE
                    </div>
                <div id="tech-th-multiple" ref="tech-th-multiple" @mouseover="techHover">
                    <img id="tech-th-multiple-img" src="/images/st-learning/ear-protection/MULTIPLE USE--THUMBNAIL--150x69.jpg" width="150" height="69" alt="electronic ear muff icon"  @mouseover="techHover" /> <br>MULTIPLE USE
                </div>
            </div>


            <div id="tech-img">
                <img src="/images/st-learning/ear-protection/img-exp-single---en.jpg" width="900" height="500" alt="single use ear plug" id="tech-img-single" ref="tech-img-single" />
                <img src="/images/st-learning/ear-protection/img-exp-multiple---en.jpg" width="900" height="500" alt="multiple use ear plug icon" id="tech-img-multiple" style="display:none;" ref="tech-img-multiple" />
            </div>

            <div id="tech-txt">
                <div id="tech-txt-single" ref="tech-txt-single">
                    <p>
                    <strong>SINGLE USE EAR PLUGS</strong> - Comfortable, soft foam plugs that are commonly used and hygienic, ideal for high contamination environments and for workplace visitors
                    </p>
                </div>

                <div id="tech-txt-multiple" style="display:none;" ref="tech-txt-multiple">
                    <p>
                        <strong>MULTIPLE USE EAR PLUGS</strong> - Easy to clean, reduce waste and save money, ideal for use in manufacturing, construction and MRO.
                    </p>
                </div>
            </div>
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider" />

        <div class="expert-div">

            <h2 class="none">Materials Basics</h2>
            <p class="main">
                Using ear plugs should be comfortable. From traditional to innovative, the materials that make up our plugs are designed for excellent performance during the task at hand, while avoiding discomfort after long periods of use.
            </p>


            <div id="material-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/ear-protection/img-earplug-pu.jpg" width="276" height="50" alt="polyurethane ear plugs" />
                        <p>
                            <strong>POLYURETHANE</strong><br />
                            Our soft polyurethane foam has a unique cellular structure that allows for slow expansion to perfectly fit the size and form of the ear canal, with a sealed surface that prevents foreign bodies from penetrating. The material provides high and immediate noise reduction.
                        </p>
                    </div>
                    
                    <div>
                        <img src="/images/st-learning/ear-protection/img-earplug-tpr.jpg" width="276" height="50" alt="thermoplastic elastomer ear plugs" />
                        <p>
                            <strong>THERMOPLASTIC ELASTOMER</strong><br />The smooth, dirt-repellent surface of TPE plugs can be cleaned using soap and water. This is ideal for dirty working environments, preventing minor injuries and irritation. It is created in a pre-formed shape and requires no rolling, making them easy to put on. Its moderate noise reduction blocks out hazardous noise yet allows warning signals and voices to be clearly understood.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/img-earplug-pvc.jpg" width="276" height="50" alt="pvc ear plugs" />
                        <p>
                            <strong>PVC</strong><br />A more traditional material for ear plugs, soft PVC foam provides high and immediate noise reduction.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>
        </div>

        <img src="/images/st-learning/tic-divider-gray.gif" class="expert-divider" />

        <div class="expert-div">
            <h2 class="none">Shape & Fit</h2>
            <p class="main">
                The shape of the ear plug is designed to bring the wearer maximum comfort. They are tailored to best fit the ear canal and deliver optimal attenuation.
            </p>
            <div id="shape-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/ear-protection/img-exp-hearing-bullet.png" width="100" height="165" alt="bullet style" />
                        <p>
                            <strong>Tapered Bullet</strong><br />Fits to the natural contour of the ear canal
                        </p>
                    </div>
                    <div>
                        <img id="compactImg" src="/images/st-learning/ear-protection/img-exp-hearing-bullet.png" width="70" height="125" alt="compact tapered style"/>
                        <p>
                            <strong>Compact Tapered Bullet</strong><br />Perfect size for users with narrow ear canals
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/img-exp-hearing-compact.png" width="100" height="165" alt="Tapered Flare style" />
                        <p>
                            <strong>Tapered Flare</strong><br />Reduces risk of back out of ear canal
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/img-exp-t-shape.png" width="100" height="165" alt="Tapered Flare style" />
                        <p>
                            <strong>T-Shape</strong><br />Easy insertion and removal from ear canal
                        </p>
                    </div>
                    
                    <div>
                        <img src="/images/st-learning/ear-protection/img-exp-hearing-traditional.png" width="100" height="165" alt="cylindrical style" />
                        <p>
                            <strong>Cylindrical</strong><br />Classic design, proven favorite for many workers
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/img-exp-hearing-flange.png" width="100" height="165" alt="flange classic style" />
                        <p>
                            <strong>Flange</strong><br />Proven design for comfort and optimal attenuation
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/img-exp-ez-twist.png" width="100" height="165" alt="flange/disc combo" />
                        <p>
                            <strong>EZ-Twist</strong><br />No rolling or pinching required. Just insert and twist
                        </p>
                    </div>
                </VueSlickCarousel> 
            </div>
        </div>

        <img src="/images/st-learning/tic-divider2-gray.gif" class="expert-divider" />

        <div class="expert-div" style="border-bottom:none;">

            <h2 class="space">Plug Styles</h2>
            <p class="main">
                These features help tailor a product to be safer and more convenient in a specific working environment, whether that means fitting in a dispenser or keeping track of plugs after removing them from the ear.
            </p>
            <div id="styles-list">
                <VueSlickCarousel v-bind="settings">
                    <div>
                        <img src="/images/st-learning/ear-protection/267-HPF610--UNCORDED--300x300.jpg" width="166" height="166" alt="uncorded ear plug style" style="margin:100px 30px 10px 30px;" />
                        <p>
                            <strong>UNCORDED</strong><br />The most economical option, and mainly for one time use. Also practical in areas where a cord may be hazardous.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/267-HPR310C--CORDED--300x300.jpg" width="236" height="236" alt="corded ear plug style" style="margin:20px;" />
                        <p>
                            <strong>CORDED</strong><br />
                            Easier to keep track of by allowing the user to wear the plugs around their neck while not in use. Can be made with rubber or non-resonating textiles, and certain styles are detachable for added safety.
                        </p>
                    </div>
                    <div>
                        <img src="/images/st-learning/ear-protection/267-HPB410--BANDED--300x300.jpg" width="226" height="226" alt="headband ear plug style " style="margin:25px;" />
                        <p>
                            <strong>BANDED</strong><br />Convenient for intermittent use. Ensures out of the way comfort and limits contact with clothing and resulting sound transmission. Prevents the plugs from contact with dirty surfaces when set down.
                        </p>
                    </div>
                </VueSlickCarousel>
            </div>
        </div>
    </div>
</template>

<script>
    import VueSlickCarousel from "vue-slick-carousel";
    import "vue-slick-carousel/dist/vue-slick-carousel.css";
    import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
    export default {
        data() {
            return {
            name: 'Vue.js',
            settings: {
                  "autoplay": false,
                  "focusOnSelect": true,
                  "infinite": false,
                  "pauseOnFocus": true,
                  "slidesToShow": 3,
                  "speed": 500,
                  "arrows":true,
                  responsive: [
                      {
                      breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                      },
                      {
                      breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                      }
                    ]
                }
            }
        },

        methods: {
            techHover(event) {
                if(event){
                    var hoveredID = event.target.id;
                    switch(hoveredID) {
                        case "tech-th-passive":
                        case "tech-th-passive-img":
                            this.$refs['tech-th-passive'].style="border-bottom:solid 3px #cd1b00;";
                            this.$refs['tech-th-electronic'].style="border-bottom: none";
                            this.$refs['tech-txt-passive'].style="display: block";
                            this.$refs['tech-txt-electronic'].style="display: none";
                            this.$refs['tech-img-passive'].style="display: block";
                            this.$refs['tech-img-electronic'].style="display: none";
                            break;
                        case "tech-th-electronic":
                        case "tech-th-electronic-img":
                            this.$refs['tech-th-passive'].style="border-bottom: none";
                            this.$refs['tech-th-electronic'].style="border-bottom: solid 3px #cd1b00;";
                            this.$refs['tech-txt-passive'].style="display: none";
                            this.$refs['tech-txt-electronic'].style="display: block";
                            this.$refs['tech-img-passive'].style="display: none";
                            this.$refs['tech-img-electronic'].style="display: block";
                            break;
                        case "tech-th-single":
                        case "tech-th-single-img":
                            this.$refs['tech-th-single'].style="border-bottom:solid 3px #cd1b00;";
                            this.$refs['tech-th-multiple'].style="border-bottom: none";
                            this.$refs['tech-txt-single'].style="display: block";
                            this.$refs['tech-txt-multiple'].style="display: none";
                            this.$refs['tech-img-single'].style="display: block";
                            this.$refs['tech-img-multiple'].style="display: none";
                            break;
                        case "tech-th-multiple":
                        case "tech-th-multiple-img":
                            this.$refs['tech-th-single'].style="border-bottom: none";
                            this.$refs['tech-th-multiple'].style="border-bottom: solid 3px #cd1b00;";
                            this.$refs['tech-txt-single'].style="display: none";
                            this.$refs['tech-txt-multiple'].style="display: block";
                            this.$refs['tech-img-single'].style="display: none";
                            this.$refs['tech-img-multiple'].style="display: block";
                            break;
                    }
                    
                }
            },
            showMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: block;";
                    this.$refs['readMore'].style="display: none;";
                    this.$refs['readLess'].style="display: block;";
                }
            },
            hideMobile(event) {
                if (event) {
                    this.$refs['mobileView'].style="display: none;";
                    this.$refs['readMore'].style="display: block;";
                    this.$refs['readLess'].style="display: none;";
                }
            },
            burgerClicked(id) {

                    if(id == "borger-1") {
                        console.log("botger-1 clicked!");
                        if (this.$refs['top-dropdown'].style.display != "block") {
                        this.$refs['top-dropdown'].style="display: block;";
                        } else {
                            this.$refs['top-dropdown'].style="display: none;";
                        }
                    } else if(id == "borger-2") {
                        console.log("botger-2 clicked!");
                        if (this.$refs['bottom-dropdown'].style.display != "block") {
                        this.$refs['bottom-dropdown'].style="display: block;";
                        } else {
                            this.$refs['bottom-dropdown'].style="display: none;";
                        }
                    }
                    console.log(event.target);
            }
        },
        components: { VueSlickCarousel }
    }

</script>
